import Url from 'urlinator/Url';
import BaseLoginDao from './BaseLoginDao';
const URL_LOADED_LOCAL = Url.loaded.local;
class MicrosoftLoginDao extends BaseLoginDao {
  initialize(credentials) {
    credentials.redirectToLocal = URL_LOADED_LOCAL;
    return this.loginAtPath('/microsoft-login/login/init', credentials);
  }
}
export default MicrosoftLoginDao;